<template xmlns="http://www.w3.org/1999/html">
    <div>
        <summary-content-panel                             @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.overview" :panel-data-key="'overview'"/>
        <summary-content-panel v-if="datasummary.decision" @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.decision" :panel-data-key="'decision'"/>
        <summary-content-panel v-if="datasummary.scoring"  @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.scoring" :panel-data-key="'scoring'"/>
        <summary-content-panel                             @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.startQuestions" :panel-data-key="'startQuestions'"/>
        <summary-content-panel                             @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.generalQuestions" :panel-data-key="'generalQuestions'"/>
        <summary-content-panel                             @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.symptoms" :panel-data-key="'symptoms'"/>
        <summary-content-panel                             @onTogglePanel="togglePanel"  :datasummary="datasummary" :is-expanded="isExpanded.sharedQuestions" :panel-data-key="'sharedQuestions'"/>
    </div>

</template>

<script>
import {mapGetters} from 'vuex';
import SummaryContentPanel from "../../../professional/components/summary/SummaryContentPanel";

export default {
        name: "SummaryContent",
    components: {SummaryContentPanel},
    data() {
      return {
          isExpanded: {
              'overview': true,
              'decision': true,
              'scoring': true,
              'startQuestions': true,
              'generalQuestions': true,
              'symptoms': true,
              'sharedQuestions': true,
          }
      }
    },
    computed: {
            ...mapGetters({
                datasummary: 'SummaryStore/getSummaryDataNew',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },

        methods: {

            /**
             * Load and display Summary data for the assessment version given as parameter.
             * @param assessmentToken
             * @param assessmentVersion
             */
            goToSummaryVersionPage(assessmentToken, assessmentVersion) {

                let urlParams = {
                    assessment: assessmentToken,
                    version: assessmentVersion
                };
                let emitPayload = {
                    assessmentToken: assessmentToken,
                    assessmentVersion: assessmentVersion,
                };

                if (typeof this.$route.query.msitat !== "undefined") {
                    urlParams.msitat = this.$route.query.msitat;
                    emitPayload.msitat = this.$route.query.msitat;
                }
                if (typeof this.$route.query.back !== "undefined" && this.$route.query.back === "true") {
                    urlParams.back = "true";
                }

                // Update the url...
                this.$router.push({
                    name: "SummaryPage",
                    query: urlParams
                }, () => { // onComplete
                    // ... then (manually) refresh the page content by emitting a custom event that will trigger
                    // an API request that brings fresh new content from the server, corresponding to the new assessment version.
                    this.$emit('onChangeSummaryVersion', emitPayload);
                });
            },


            togglePanel(panelObject) {
                this.isExpanded[panelObject.sectionKey] = panelObject.isExpanded;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/shared/SummaryContent.vue